import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { Cell } from 'components/HonestTable/HonestTable.styled'
import { IKitchenIngredient } from 'types/kitchen/kitchenIngredient.interface'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'

interface IProps {
  ingredients: IKitchenIngredient[]
}

export const IngredientsTab = ({ ingredients }: IProps) => {
  const columns: IHonestTableColumn<IKitchenIngredient>[] = [
    {
      id: 'name',
      header: 'Ingredient',
      sticky: true,
      minWidth: '10rem',
      cell: (i) => (
        <Cell>
          <BodyText weight='600'>{i.name}</BodyText>
        </Cell>
      ),
    },
    {
      id: 'sku',
      header: 'SKU link',
      cell: (i) => <StatusPill status='accent'>SKU-F{100 + i.id}</StatusPill>,
    },
    {
      id: 'unit',
      header: 'Stock unit',
      cell: (i) => <BodyText>{i.unit}</BodyText>,
    },
    {
      id: 'recipeUnit',
      header: 'Recipe unit',
      cell: (i) => <BodyText>{i.recipeUnit}</BodyText>,
    },
    {
      id: 'conversion',
      header: 'Conversion',
      cell: (i) => (
        <BodyText>
          1 {i.unit} = {i.factor} {i.recipeUnit}
        </BodyText>
      ),
    },
  ]

  return (
    <Container>
      <ContainerHeader>
        <TitleText weight='700'>Ingredients — culinary master data over central Inventory SKUs</TitleText>
      </ContainerHeader>
      <ContainerContent gap='0.625rem'>
        <HonestTable columns={columns} data={ingredients} keyField='id' />
        <OtherText grey>
          Stock, batches, expiry and prices live in the Inventory ledger and surface only where decisions need them: feasibility (Menu Planner), Suggestions, Dashboard store health, and recipe costing.
        </OtherText>
      </ContainerContent>
    </Container>
  )
}
